import Vue from 'vue'
import Vuex from 'vuex'

import employee from './modules/employee'
import payroll from './modules/payroll'
import leave from './modules/leave'
import newsfeed from './modules/newsfeed'
import timesheet from './modules/timesheet'
import userManagement from './modules/userManagement'
import timesheetformodification from './modules/timesheetformodification'
import thirteenmonthpay from './modules/thirteenmonthpay'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    employee,
    payroll,
    leave,
    timesheet,
    userManagement,
    timesheetformodification,
    newsfeed,
    thirteenmonthpay
  }
})